import React from "react";
import PropTypes from "prop-types";

import BluGraphContainer from "./common/BluGraphContainer";

import EndpointAttacksGraph from "./EndpointAttacksGraph";

import "./common/BluGraphContainer.scss";

/*
Constants
*/

const REDUX_NAME = "endpointAttacks";
export const GRAPH_TITLE = "Top 10 Attacks against Endppoints";

/*
Main component
*/

const EndpointAttacks = ({ showTitle = false, showSubtitle = true }) => (
  <BluGraphContainer
    defaultTitle={GRAPH_TITLE}
    Graph={EndpointAttacksGraph}
    reduxName={REDUX_NAME}
    showSubtitle={showSubtitle}
    showTitle={showTitle}
  />
);

EndpointAttacks.propTypes = {
  showSubtitle: PropTypes.bool,
  showTitle: PropTypes.bool,
};

EndpointAttacks.defaultProps = {
  showSubtitle: true,
  showTitle: false,
};

export default EndpointAttacks;
